// Constants used for specific settings unique to the widget mode
export const WIDGET_HIDE = 'close the widget';
export const WIDGET_CLOSE = 'close the widget for real';
export const SET_WIDGET_VIEW = 'set widget view';
export const SET_WIDGET_OPEN_STATE = 'set widget open state';

// Used for sending a message from outside the widget
export const SEND_MESSAGE_IF_NOT_SENT = 'send message if not sent';
